import React from 'react';
import BaseContainer from './BaseContainer.tsx';
import SimpleHeader from '../GameHeader/SimpleHeader.tsx';

interface GameContainerProps {
  children: React.ReactNode;
  title: string;
}

export default function GameContainer(props: GameContainerProps) {
  const { children, title } = props;

  const header = (
    <SimpleHeader
      title={title}
    />
  );

  return (
    <BaseContainer header={header}>
      {children}
    </BaseContainer>
  );
} 